import { useTranslation } from "next-i18next";
import { Box, Link } from "@mui/material";
import { ErrorPageLayout } from "@Components/layout/ErrorPageLayout";
import { getCMSPageModel } from "@Libs/contentful/components/CmsPage";
import NotFoundPageQuery from "@Libs/contentful/queries/NotFoundPage";
import { pageModel } from "@Types/Contentful";
import NextLink from "@wff/components/Link";
import { makeStaticProps, getStaticPaths } from "@wff/libs/i18n/getStatic";
interface NotFoundPageProps {
  pageModel: pageModel;
}

const Page404 = ({ pageModel }: NotFoundPageProps) => {
  const { pageContent = {} } = pageModel;
  const { t } = useTranslation();
  const { pageTitle, pageDescription, heading, content, continueShoppingLink } =
    pageContent;

  return (
    <ErrorPageLayout
      pageTitle={pageTitle ?? t("general.404.title")}
      pageDescription={pageDescription ?? t("general.404.subtext")}
    >
      <Box height="50vh" padding="2rem">
        <h1>{heading ?? t("general.404.title")}</h1>
        <p>{content ?? t("general.404.subtext")}</p>
        <NextLink href={continueShoppingLink?.href ?? "/"}>
          <Link>{continueShoppingLink?.text ?? t("general.404.link")}</Link>
        </NextLink>
      </Box>
    </ErrorPageLayout>
  );
};

const overrideStaticProps = async (props: any) => {
  const { locale } = props;

  const pageModel = await getCMSPageModel(NotFoundPageQuery, {
    locale,
  });

  return {
    props: {
      pageModel,
    },
    revalidate: 10, // TODO:- Set revalidation timeout based on the Architecture discussion
  };
};

const getStaticProps = makeStaticProps(["common"], overrideStaticProps);
export { getStaticPaths, getStaticProps };

export default Page404;
